import { render, staticRenderFns } from "./TableViewer.vue?vue&type=template&id=00bb78d2&"
import script from "./TableViewer.vue?vue&type=script&lang=js&"
export * from "./TableViewer.vue?vue&type=script&lang=js&"
import style0 from "./TableViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports